import React from "react";
import { Image, Row, Col, Container, Button } from "react-bootstrap";


const NoPage = () => {
  return (
    <Container fluid className="nopage-container">
     
    </Container>
  );
};

export default NoPage;
